var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"telegram-setting"},[_c('text-input',{attrs:{"setup":{
      'func': _vm.modelSetter,
      'args': {
        'model': _vm.model,
        'key': 'token',
        'prefix': 'cash_register_telegram_',
        'validation': 'required'
      }
    }}}),_c('select-input',{attrs:{"setup":{
      'func': _vm.providerTypeSetter,
      'args': {
        'model': _vm.model,
        'key': 'provider_type',
        'prefix': 'cash_register_telegram_',
        'options': _vm.telegramProviderTypeOptions,
        'clearable': true,
      },
    }}}),(_vm.model.provider_type === 'Yookassa')?_c('nested-content',[_c('switch-input',{attrs:{"setup":{
        'func': _vm.modelSetter,
        'args': {
          'model': _vm.model,
          'key': 'send_receipt',
          'prefix': 'cash_register_telegram_',
        }
      }},on:{"change":_vm.onYookassaAddReceiptChange}}),(_vm.model.send_receipt)?[_c('select-input',{attrs:{"setup":{
          'func': _vm.modelSetter,
          'args': {
            'model': _vm.model,
            'key': 'vat_code',
            'options': _vm.yookassaVatCodeOptions,
            'clearable': false,
            'prefix': 'cash_register_yookassa_',
            'validation': 'required'
          }
        }}})]:_vm._e()],2):_vm._e(),_c('switch-input',{attrs:{"setup":{
      'func': _vm.modelSetter,
      'args': {
        'model': _vm.model,
        'key': 'need_email',
        'prefix': 'cash_register_telegram_',
      }
    }}}),_c('switch-input',{attrs:{"setup":{
      'func': _vm.modelSetter,
      'args': {
        'model': _vm.model,
        'key': 'need_name',
        'prefix': 'cash_register_telegram_',
      }
    }}}),_c('switch-input',{attrs:{"setup":{
      'func': _vm.modelSetter,
      'args': {
        'model': _vm.model,
        'key': 'need_phone',
        'prefix': 'cash_register_telegram_',
      }
    }}}),_c('switch-input',{attrs:{"setup":{
      'func': _vm.modelSetter,
      'args': {
        'model': _vm.model,
        'key': 'need_address',
        'prefix': 'cash_register_telegram_',
      }
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }